<template>
  <div>

    <!-- ─── DEV SYSTEM BAR (level < 3) ──────────────────────────── -->
    <template v-if="settings.level && settings.level < 0">
      <v-system-bar color="white" class="text-weight-black" fixed
      >
        iBookRestaurant.com
      </v-system-bar>
    </template>


    <!-- ─── MAIN APP BAR ─────────────────────────────────────────── -->
    <template v-else>
    <v-app-bar
      app flat
      :clipped-left="isClippedLeft"
      :clipped-right="isClippedRight"
      v-if="isVisibleHeader"
      v-bind="bindStyle"
      :dense="isDense"
      height="60"
      :prominent="isProminent"
      :hide-on-scroll="isHideOnScroll"
      :shrink-on-scroll="isShrinkOnScroll"
      class="elevation-8 px-0"
      :class="settings.level && settings.level < 3 ? 'mt-6' : 'mt-2'"
    >
      <!-- Brand -->
      <toolbar-logo />

      <v-spacer />

      <!-- ── CLIENT LEVEL (level ≤ 2) ──────────────────────────── -->
      <!--
      <template v-if="settings && settings.level <= 2">
        <dark-mode-toggle />
        <user-avatar v-if="$vuetify.breakpoint.mdAndUp" />
      </template>
      -->

      <!-- ── STAFF / BOSS LEVEL (level > 2) ────────────────────── -->
      <template v-if="settings && settings.level > 2">

        <dark-mode-toggle />

        <!-- Desktop -->
        <template v-if="$vuetify.breakpoint.mdAndUp">

          <!-- Common module buttons -->
          <nav-button
            v-for="(m, mi) in visibleModules"
            :key="mi"
            :icon="m.icon"
            :icon-color="m.iconColor"
            :path="m.path"
            :tooltip="m.title"
            :large="true"
            :disabled="m.umActive"
            :is-stats-button="m.path === '/stats'"
            :unshown-count="m.path === '/agenda' ? unshown : 0"
            :unconfirmed-count="m.path === '/agenda' ? unconfirmed : 0"
            :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
            @click="m.path === '/stats' ? (dialog_pwd = true) : null"
          />

          <!-- Boss-only buttons (level 1000) -->
          <template v-if="settings.level === 1000">
            <nav-button icon="mdi-account-group" icon-color="info"
              path="users" tooltip="Clienti" :large="true"
              :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'" />

            <nav-button icon="mdi-mailbox" icon-color="success"
              path="campaigns" tooltip="Campagne Marketing" :large="true"
              :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'" />

            <nav-button icon="mdi-invoice" icon-color="warning"
              path="invoiceData" tooltip="Dati Fatturazione" :large="true"
              :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'" />

            <nav-button icon="mdi-currency-eur" icon-color="green"
              path="/boss/stripe" tooltip="Stripe Fees" :large="true"
              :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'" />
          </template>

          <!-- Super-admin avatar + tools (level > 1000) -->
          <template v-if="settings.level > 1000">
            <user-avatar />
          </template>

          <!-- Subscribe (paid, non-boss) -->
          <nav-button
            v-if="settings.level > 100 && settings.level < 1000"
            icon="mdi-shopping"
            :icon-color="!bindStyle.color ? settings.options.color : bindStyle.color"
            path="/settings/?pageId=services"
            tooltip="Subscribe"
            :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
          />

          <!-- Logout -->
          <nav-button
            icon="mdi-exit-to-app"
            :icon-color="!bindStyle.color ? settings.options.color : bindStyle.color"
            path="/auth/logout"
            tooltip="Logout"
            :large="true"
            :button-class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
          />

        </template>

        <!-- Mobile hamburger menu -->
        <v-menu v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mr-0" v-on="on" v-bind="attrs">
              <v-avatar :size="$vuetify.breakpoint.xs ? 40 : 52">
                <v-img
                  :src="settings.avatar
                    ? `/static/users/pictures/avatar/${settings.avatar}`
                    : '/static/users/pictures/avatar/unknown.png'"
                />
              </v-avatar>
            </v-btn>
          </template>

          <v-list class="neu-glow-inset full-height-64ex mt-16">

            <!-- Module buttons -->
            <v-list-item v-for="(m, mi) in visibleModules" :key="mi" class="mx-0 px-1">
              <nav-button
                :icon="m.icon" :icon-color="m.iconColor"
                :path="m.path" :tooltip="m.title"
                :large="true" :disabled="m.umActive"
                :is-stats-button="m.path === '/stats'"
                :unshown-count="m.path === '/agenda' ? unshown : 0"
                :unconfirmed-count="m.path === '/agenda' ? unconfirmed : 0"
                button-class="neu-glow mx-3 my-2" left
                @click="m.path === '/stats' ? (dialog_pwd = true) : null"
              />
            </v-list-item>

            <!-- Logout -->
            <v-list-item class="mx-0 px-1">
              <nav-button
                icon="mdi-exit-to-app"
                :icon-color="!bindStyle.color ? settings.options.color : bindStyle.color"
                path="/auth/logout" tooltip="Logout"
                :large="true" button-class="neu-glow mx-3 my-2"
              />
            </v-list-item>

            <!-- Subscribe (paid, non-boss) -->
            <v-list-item
              v-if="settings.level > 100 && settings.level < 1000"
              class="mx-0 px-1"
            >
              <nav-button
                icon="mdi-shopping"
                :icon-color="!bindStyle.color ? settings.options.color : bindStyle.color"
                path="/settings/?pageId=services" tooltip="Subscribe"
                button-class="neu-glow mx-3"
              />
            </v-list-item>

          </v-list>
        </v-menu>

      </template>
      <!-- ── END STAFF / BOSS ──────────────────────────────────── -->

    </v-app-bar>
    </template>
    <!-- ─── STATS PASSWORD DIALOG ────────────────────────────────── -->
    <v-dialog max-width="400" persistent v-model="dialog_pwd">
      <v-card class="pb-4">
        <v-card-title class="text-h5 mb-3">
          Inserisci Password
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="checkPwd()">
                <v-icon color="success">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>Procedi</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_pwd = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Esci</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-row class="mx-5 mt-2">
          <v-col md="12" cols="12">
            <v-text-field
              label="Password" outlined autocomplete="off" color="info"
              prepend-inner-icon="mdi-lock" v-model="statsPWD"
              counter="10" hint="Password per accesso KPI"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
//import NavButton from './components/NavButton.vue'
//import ToolbarLogo from './components/ToolbarLogo.vue'
//import UserAvatar from './components/UserAvatar.vue'
//import DarkModeToggle from './components/DarkModeToggle.vue'

export default {
  name: 'ToolbarFix',
  
  components: {
    /*NavButton,
    ToolbarLogo,
    UserAvatar,
    DarkModeToggle
    */
  },
  
  props: {
    handleSettingsDrawer: Function
  },
  
  data() {
    return {
      wIW: window.innerWidth,
      TBM: null,
      unshown: null,
      unconfirmed: null,
      dialog_pwd: false,
      realStatsPWD: '123qw',
      statsPWD: null,
      polling: null,
    }
  },
  
  computed: {
    ...mapGetters('scheme', ['dark', 'semidark', 'header', 'footer', 'rtl']),
    ...mapGetters(['settings', 'other_settings', 'formattedTimeframe']),
    ...mapGetters('navigations', [
      'isVisibleHeader',
      'isSidenavPostionRight',
      'isClippedOver',
      'isMinSideNav',
      'isDense',
      'isProminent',
      'isHideOnScroll',
      'isShrinkOnScroll',
      'isFloating'
    ]),
    
    visibleModules() {
      if (!this.settings || !this.settings.modules) return []
      
      return this.settings.modules.filter(m => 
        this.settings.level >= m.level && this.settings.level <= m.maxLevel
      )
    },
    
    isClippedRight() {
      return this.isClippedOver && this.isSidenavPostionRight
    },
    
    isClippedLeft() {
      return this.isClippedOver && !this.isSidenavPostionRight
    },
    
    bindStyle() {
      const { color, dark, classes } = this.header
      return {
        class: {
          'vuse-header': true,
          'with-radius': true,
          [classes]: true,
          'mx-1': this.isFloating && !this.isClippedOver,
          'mx-2': this.$vuetify.breakpoint.mdAndUp
        },
        dark,
        color
      }
    }
  },
  
  created() {
    if (this.settings && this.settings.level > 20) {
      this.getData()
      this.pollData()
    }
  },
  
  beforeDestroy() {
    if (this.polling) {
      clearInterval(this.polling)
    }
  },
  
  methods: {
 

    checkPwd() {
      if (this.statsPWD === this.realStatsPWD) {
        this.statsPWD = null
        this.dialog_pwd = false
        this.$router.push('/stats').catch(() => {})
      }
    },
    
    pollData() {
      const delay = localStorage.getItem('dev')
        ? 500000000000
        : this.settings.options.refreshRate
          ? parseInt(this.settings.options.refreshRate) * 1000
          : 5000000000
      
      this.polling = setInterval(() => {
        if (!this.showManualAssignMap && !this.showiManagerMap) {
          this.getData()
        }
      }, delay)
    },
    
    async getData() {
      try {
        const payload = JSON.stringify({
          date: this.date,
          action: 'manage_toolbarBadges_get',
          jwt: 0
        })
        
        const res = await this.$http.post('/manage/manage.php', payload)
        
        if (res.data.errorid === '0') {
          const p = res.data.payloads
          this.unshown = p.unshown.cnt
          this.unconfirmed = p.unconfirmed.cnt
        } else if (res.data.errorid === '0006') {
          this.$router.push('/auth/login').catch(() => {})
        }
        
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-btn__content {
  text-align: center !important;
}
</style>
